export default "__VITE_ASSET__67gONmgG__"